import React, {FC, useState,MouseEvent } from "react";
import {Link, useNavigate} from "react-router-dom";
import {MenuList} from "../..";
import {RoutePageConfigurations, SystemConfiguration} from "../../../configuration";
import {MenuModel} from "../../../models";
import {
    isArabicCurrentLanguage,
    isUserAuthenticated,
    secureLocalStorageGet,
} from "../../../utils";
import logo from "../../../assets/images/logo-sidebar.svg";
import logomini from "../../../assets/images/logo-mini.svg";

export const LayoutHeader: FC<any> = () => {
    //#region variables
    const isArabic: boolean = isArabicCurrentLanguage();
    let menuItems: MenuModel[] = JSON.parse(
        secureLocalStorageGet(SystemConfiguration.cacheKey_Configurations.menu.menu || "") as string
    ) as MenuModel[];
    //#endregion
    //#region state
    const [isOpen] = useState(false);
    const navigate = useNavigate();
    //#endregion
    //#region function
    const handleLogoClick = (e: MouseEvent<HTMLAnchorElement>) => {
        // If user is already authenticated, navigate to dashboard instead of home
        if (isUserAuthenticated()) {
            e.preventDefault(); // Prevent default link behavior
            navigate(RoutePageConfigurations.miscellaneous.dashboardPage);
        }
        // If not authenticated, let the default link behavior navigate to home
    };
    //#endregion
    //#region html
    return (
        <>
            {isUserAuthenticated() && (
                <>
                    <div className="main-sidebar">
                        <nav className="sidebar sidebar-offcanvas">
                            <div
                                className="text-center navbar-brand-wrapper d-flex align-items-center justify-content-start">
                                <Link className="navbar-brand brand-logo" to="/"  onClick={(e) => handleLogoClick(e)}>
                                    <img src={logo} alt="logo"/>
                                </Link>
                                <Link className="navbar-brand brand-logo-mini" to="/" onClick={(e) => handleLogoClick(e)}>
                                    <img src={logomini} alt="logo" />
                                </Link>
                            </div>
                            <ul className="nav">
                                {isUserAuthenticated() &&
                                    menuItems !== null &&
                                    menuItems !== undefined &&
                                    menuItems.length !== 0 && !isOpen && menuItems.length !== 0 && (
                                        <MenuList request={menuItems} isArabic={isArabic}/>
                                    )}
                            </ul>
                        </nav>
                    </div>
                </>
            )}
        </>
    );
    //#endregion
};
